import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  
  .heading {
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e3f2fd;
    
    h1 {
      font-size: 36px;
      line-height: 48px;
      color: #1a237e;
      font-weight: 700;
      margin-bottom: 8px;
      background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    p {
      font-size: 16px;
      line-height: 24px;
      color: #546881;
      font-weight: 400;
    }
  }
  h3 {
    font-size: 24px;
    line-height: 32px;
    color: #1a237e;
    font-weight: 600;
    margin: 30px 0 20px 0;
    padding-left: 8px;
    border-left: 4px solid #03a9f4;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 24px;
  margin-bottom: 40px;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartWrapper = styled.div`
  margin-top: 30px;
  gap: 24px;
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  border: 1px solid #e3f2fd;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  .right {
    width: 70%;
  }
  .left{
    //width: 50px
  }
  @media screen and (max-width: 668px) {
    flex-direction: column;
  }
`;
export const TableWrapper = styled.div`
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  border: 1px solid #e3f2fd;
  margin-top: 30px;
  
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 18px;
        color: #1a237e;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e3f2fd;
    
    h3 {
      font-size: 22px;
      color: #1a237e;
      font-weight: 600;
      margin-bottom: 4px;
    }
    p {
      margin-top: 5px;
      font-size: 14px;
      color: #546881;
    }
    .link-buttons {
      display: flex;
      gap: 12px;
      align-items: center;
      
      .see-more,
      .add-campaign {
        padding: 10px 20px;
        height: 42px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 500;
        text-decoration: none;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      
      .see-more {
        border: 2px solid #03a9f4;
        background-color: transparent;
        color: #03a9f4;
        
        &:hover {
          background-color: #03a9f4;
          color: #ffffff;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(3, 169, 244, 0.3);
        }
      }
      
      .add-campaign {
        color: #fff;
        border: 2px solid #03a9f4;
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
        box-shadow: 0 2px 8px rgba(3, 169, 244, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px rgba(3, 169, 244, 0.4);
        }
      }
    }
  }
`;
